<template>
    <div class="device">
        <div class="top-banner">
            <div class="main_content">
                <div class="top-banner-title">下载番茄打印管家</div>
                <div class="top-banner-list">
                    <div class="top-banner-list-item" @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">
                        <img class="top-banner-list-item-img" src="./images/win.png" alt="icon">
                        <img class="top-banner-list-item-img-hover" src="./images/down.png" alt="icon">
                        <div class="top-banner-list-item-text">Windows</div>
                    </div>
                    <div class="top-banner-list-item" @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">
                        <img class="top-banner-list-item-img" src="./images/mac.png" alt="icon">
                        <img class="top-banner-list-item-img-hover" src="./images/down.png" alt="icon">
                        <div class="top-banner-list-item-text">MacOS</div>
                        <div class="top-banner-list-item-subtext">intel芯片版</div>
                    </div>
                    <div class="top-banner-list-item" @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">
                        <img class="top-banner-list-item-img" src="./images/mac.png" alt="icon">
                        <img class="top-banner-list-item-img-hover" src="./images/down.png" alt="icon">
                        <div class="top-banner-list-item-text">MacOS</div>
                        <div class="top-banner-list-item-subtext">Apple芯片版</div>
                    </div>
                    <div class="top-banner-list-item" @click="openNew('https://gj.fanqie365.cn/?sc=guanwang')">
                        <img class="top-banner-list-item-img" src="./images/huawei.png" alt="icon">
                        <img class="top-banner-list-item-img-hover" src="./images/down.png" alt="icon">
                        <div class="top-banner-list-item-text">HarmonyOS</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="device_container device_container_gray">
            <div class="main_content">
                <div class="device_container-title">二步搞定驱动安装</div>
                <div class="steps">
                    <div class="step-item">
                        <img class="step-item-icon" src="./images/step1.png" alt="step">
                        <div class="step-item-content">
                            <div class="step-item-content-title">Step1</div>
                            <div class="step-item-content-text">下载番茄打印管家并安装成功，请辨别电脑系统和版本。</div>
                        </div>
                    </div>
                    <img class="step-arrow" src="./images/arrow.png" alt="arrow">
                    <div class="step-item">
                        <img class="step-item-icon" src="./images/step2.png" alt="step">
                        <div class="step-item-content">
                            <div class="step-item-content-title">Step2</div>
                            <div class="step-item-content-text">打印机开机后，连接usb数据线，3秒内驱动自动安装成功。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="device_container device_container_white">
            <div class="main_content content1">
                <div class="content-tabs">
                    <div class="content-tab" :class="{active: tabIndex === 0}" @click="tabIndex=0">常用打印机型号</div>
                    <div class="content-tab" :class="{active: tabIndex === 1}" @click="tabIndex=1">其他型号驱动</div>
                </div>
                <div class="content-tab1" v-if="tabIndex === 0">
                    <div class="content-tab-item">
                        <img class="content-tab-item-img" src="./images/bg1.png" alt="img">
                        <div class="content-tab-item-box">
                            <div class="content-tab-item-text" style="line-height: 30rem;">
                                KM-202，KM-202BT，KM-202M，KM-202MBT，KM202MD，<br/>
                                KM-202ME，KM-202MGD，KM-202M(NEW)，KM-202MBT(NEW)，<br/>
                                KM-202MQ(NEW)，KM-202Q，KM-218M(NEW)，KM-118，KM-118BT，<br/>
                                KM-118BT(NEW)，KM-118C，KM-118D，KM-118DE，KM118DX，<br/>
                                KM-118HD，KM-118HBD，KM-118HD(NEW)，KM-118M，KM-118MBT，<br/>
                                KM118E，KM118ME，KM118EB，KM118MEB，KM-118MWA，KM-118S，<br/>
                                KM-218，KM-218M，KM-218mini，KM-218BT，KM218miniBT，<br/>
                                KM-218MGC，KM-106，KM-106D，KM-106HD，KM-106M，KM-106ME，<br/>
                                RE428，RE428X，RX106HD，RX106M，KM-116，KM-186，KM-K18，<br/>
                                KM-K18BT，KM-K28，KM-K28BT，KM-QS-Q6S，KM-167，KM-167BT，<br/>
                                KM-360P，KM-QS-Q7，KM-360SE，KM-T41，SE210，SE210BT，SE211，<br/>
                                SE211BT，E20W，E20WA，E31，E31W，E41，E41W，KE-G31，KE-G41，<br/>
                                KJ-X3MSF，POCKET-S6，FX416，KM-UP380BT，KM-200，UL410BT，<br/>
                                RE418，RE418BT，RX496，RX496BT，RX106F，RX416，CX418，CX418HD，<br/>
                                QP380，T300，ET411HQ(NEW)，LP380C，LP380BC，LP380EC，KM-360A，<br/>
                                RE210，SC310，STENCIL_S7，KDZS001
                            </div>
<!--                            <div class="content-tab-item-title">面单打印机：</div>
                            <div class="content-tab-item-text">
                                KM-202、KM-202BT、KM-202M、KM-202MBT、KM-118、KM-118D、KM-118BT、<br/>
                                KM-118M、KM-118MBT、KM-118C、KM-118S、KM-118HD、KM-218M、KM-218<br/>
                                、KM-218BT、KM-106、KM-106M 、KM-106ME、RX106HD、KM-116、KM-186、<br/>
                                KM-K18、KM-K18BT、KM-K28、KM-K28BT、KM202MD、KM-202D、ET311、ET311HD、<br/>
                                ET411、ET411HB、FX410、KM-118DE、KJ-X3MSF
                            </div>
                            <div class="content-tab-item-title">标签打印机：</div>
                            <div class="content-tab-item-text">
                                SE210、SE210BT、SE211、SE211BT、KM-167、KM-167BT
                            </div>-->
                        </div>
                    </div>
                    <div class="content-tab-item">
                        <img class="content-tab-item-img" src="./images/bg2.png" alt="img">
                        <div class="content-tab-item-box">
                            <div class="content-tab-item-text" style="line-height: 30rem;">
                                CX418，KM-118(NEW)，KM-118MBT，KM-202BT(NEW)，<br/>
                                KM-202M(NEW)，RE418，KM-118D，KM-202(NEW)，KM-202BT，<br/>
                                KM-202MD，LP380BC，RX106F，KM-106D，KM-118HD(NEW)，<br/>
                                KM-202，KM-202D，RX416，KM-118，KM-118T，KM-202M，<br/>
                                KM-202ME，KM-202MBT，KM-200，KM118DW，KM118MW，KM-K18，<br/>
                                KM-K28，KM-218mini、K18BT、K28BT、KM-G31、KM-G41、KM118ME、<br/>
                                KM118E、KM118MEB、KM118EB、RE210
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-tab2" v-else>
                    <table>
                        <tr>
                            <th>打印机型号</th>
                            <th>系统</th>
                            <th>驱动下载</th>
                            <th>安装教程</th>
                        </tr>
                        <tr v-for="(device, index) in deviceList" :key="device.col1 + index">
                            <td>{{ device.col1 }}</td>
                            <td>{{ device.col2 }}</td>
                            <td>
                                <div class="btn-download" @click="openNew(device.col3)">
                                    立即下载
                                    <img src="./images/download.png" alt="download">
                                </div>
                            </td>
                            <td>
                                <div class="btn-view" @click="openNew('https://dyj-old.kuaimai.com/cpdt/3302.html')">
                                    立即查看
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DeviceDownload",
    data() {
        return {
            tabIndex: 0,
            deviceList: [
                {
                    col1: "RX106、RX106D、RX106MY、KM-106MBT",
                    col2: "Windows",
                    col3: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/qdxz/106/KM_Driver_R_win_V3.15_211202 .exe",
                    col4: "",
                },
                {
                    col1: "KM-202G、KM-202SP、 KM-202MQ、KM-202Q 、 KM-188",
                    col2: "Windows",
                    col3: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/qdxz/202KuaiMai Printer Driver Setup Ver1.3.0.1_ONLINE.exe",
                    col4: "",
                },
                {
                    col1: "KM-118T 、KM-118J、KM-100、KM-200系列、KM-108系列、KM-1100、CI250",
                    col2: "Windows",
                    col3: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/qdxz/118KM_Driver_C_win_1.0.220122_RC.exe",
                    col4: "",
                },
                {
                    col1: "SC310",
                    col2: "Windows",
                    col3: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/qdxz/SC310DRV-TSPL-LABEL(v2.7)_SC310_20220321.exe",
                    col4: "",
                },
                {
                    col1: "KM-202MGD、KM-218MGD",
                    col2: "Windows",
                    col3: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/qdxz/202MGDPDDCloudPrinter_V1.0.5.1_Build20250305213001_Final.exe",
                    col4: "",
                },
                {
                    col1: "KM-118Q、KM-106Q、RX106MEQ",
                    col2: "Windows",
                    col3: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/qdxz/118QKM_Driver_RQSeries_win_V1.02_211202.exe",
                    col4: "",
                },
                {
                    col1: "SX320系列",
                    col2: "Windows",
                    col3: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/qdxz/sx320DRV-TSPL-LABEL(v2.7)_signed_20211123.exe",
                    col4: "",
                },
            ]
        };
    },
    mounted() {
    },
    methods: {},
};
</script>

<style scoped lang="scss">
.device {
    .top-banner {
        box-sizing: border-box;
        padding-top: 155rem;
        height: 500rem;
        background: url("./images/bg.png") center / 1920rem 500rem no-repeat;

        .main_content {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .top-banner-title {
            margin: 0 0 16rem 0;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 40rem;
            color: #333333;
            line-height: 90rem;
        }

        .top-banner-list {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 24rem;

            .top-banner-list-item {
                box-sizing: border-box;
                width: 180rem;
                height: 200rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-top: 52rem;
                background: #FFFFFF;
                border-radius: 16rem;
                cursor: pointer;

                &:hover {
                    background: #FD6520;
                    box-shadow: 0 2rem 20rem 0 rgba(0, 0, 0, 0.1);

                    .top-banner-list-item-img {
                        display: none;
                    }

                    .top-banner-list-item-img-hover {
                        display: block;
                    }

                    .top-banner-list-item-text, .top-banner-list-item-subtext {
                        color: #FFFFFF;
                    }
                }

                .top-banner-list-item-img {
                    height: 52rem;
                }

                .top-banner-list-item-img-hover {
                    display: none;
                    height: 52rem;
                }

                .top-banner-list-item-text {
                    margin-top: 16rem;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 20rem;
                    color: #333333;
                    line-height: 28rem;
                }

                .top-banner-list-item-subtext {
                    margin-top: 7rem;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 14rem;
                    color: #999999;
                    line-height: 20rem;
                }
            }
        }
    }

    .device_container {
        padding: 56rem 0 60rem;

        &.device_container_gray {
            background: #F2F3F5;
        }

        &.device_container_white {
            background: #FFFFFF;
        }

        .device_container-title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 36rem;
            color: #333333;
            line-height: 50rem;
        }

        .steps {
            margin-top: 28rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .step-item {
                display: flex;
                flex-direction: row;
                box-sizing: border-box;
                padding: 28rem;
                width: 560rem;
                height: 140rem;
                background: #FFFFFF;
                border-radius: 20rem;
                gap: 8rem;

                .step-item-icon {
                    margin-top: 12rem;
                    width: 48rem;
                    height: 48rem;
                }

                .step-item-content {
                    .step-item-content-title {
                        margin-bottom: 12rem;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        font-size: 36rem;
                        color: #333333;
                        line-height: 50rem;
                    }

                    .step-item-content-text {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 16rem;
                        color: #333333;
                        line-height: 22rem;
                    }
                }
            }

            .step-arrow {
                width: 72rem;
            }
        }


        .content1 {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .content-tabs {
            margin-bottom: 38rem;
            border-radius: 100rem;
            overflow: hidden;
            display: flex;
            align-items: center;
            background: #FFFFFF;
            border: 1px solid #CCCCCC;
            padding: 2rem;

            .content-tab {
                padding: 14rem 36rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 18rem;
                color: #666666;
                line-height: 22rem;
                border-radius: 100rem;
                cursor: pointer;

                &.active {
                    color: #FFFFFF;
                    background: #FD6520;
                }
            }
        }

        .content-tab1 {
            display: flex;
            flex-direction: row;
            gap: 40rem;

            .content-tab-item {
                //height: 400rem;
                background: #F5FAFF;
                border-radius: 20rem;
                overflow: hidden;

                .content-tab-item-img {
                    height: 120rem;
                }

                .content-tab-item-box {
                    padding: 24rem 26rem;

                    .content-tab-item-title {
                        margin-bottom: 16rem;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: 20rem;
                        color: #333333;
                        line-height: 28rem;
                    }

                    .content-tab-item-text {
                        margin-bottom: 20rem;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14rem;
                        color: #333333;
                        line-height: 20rem;
                    }
                }
            }
        }

        .content-tab2 {
            width: 100%;

            table {
                width: 100%;
                border: 1px solid #CCCCCC;
                background: #FFFFFF;

                tr {
                    height: 64rem;


                    &:nth-child(even) {
                        background: #F9F9F9;
                    }

                    th {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: 14rem;
                        color: #333333;
                        line-height: 20rem;
                        vertical-align: middle;
                        padding: 0 40rem;
                        text-align: center;

                        &:first-child {
                            text-align: left;
                        }
                    }

                    td {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: 14rem;
                        color: #333333;
                        line-height: 20rem;
                        vertical-align: middle;
                        padding: 0 40rem;
                        text-align: center;

                        &:first-child {
                            text-align: left;
                        }
                    }
                }
            }

            .btn-download {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                width: 106rem;
                height: 34rem;
                background: #FD6520;
                border-radius: 4rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 14rem;
                color: #FFFFFF;
                gap: 8rem;
                cursor: pointer;

                img {
                    width: 14rem;
                }
            }

            .btn-view {
                padding: 7rem 20rem;
                border-radius: 4rem;
                border: 1px solid #FD6520;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 14rem;
                color: #FD6520;
                text-align: center;
                cursor: pointer;
            }
        }
    }
}
</style>
